'use client';
'use strict';

var React = require('react');
var cx = require('clsx');
var core = require('@mantine/core');
var TimeInput_module = require('./TimeInput.module.css.cjs');

const defaultProps = {};
const TimeInput = core.factory((_props, ref) => {
  const props = core.useProps("TimeInput", defaultProps, _props);
  const { classNames, styles, unstyled, vars, withSeconds, ...others } = props;
  const { resolvedClassNames, resolvedStyles } = core.useResolvedStylesApi({
    classNames,
    styles,
    props
  });
  return /* @__PURE__ */ React.createElement(
    core.InputBase,
    {
      classNames: { ...resolvedClassNames, input: cx(TimeInput_module.input, resolvedClassNames?.input) },
      styles: resolvedStyles,
      unstyled,
      ref,
      ...others,
      step: withSeconds ? 1 : 60,
      type: "time",
      __staticSelector: "TimeInput"
    }
  );
});
TimeInput.classes = core.InputBase.classes;
TimeInput.displayName = "@mantine/dates/TimeInput";

exports.TimeInput = TimeInput;
//# sourceMappingURL=TimeInput.cjs.map
